import { useState, useContext, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Card,
  CardBody,
  Container,
} from "reactstrap";
import { Plus } from "react-feather";

import SharedDataContext from "../../../_helper/SharedData";

import CustomTabs from "../../../CommonElements/CommonTabs/CustomTabs";
import { Breadcrumbs, Btn } from "../../../AbstractElements";

import ServiceCityForm from "../Forms/ServiceCityForm";
import ServiceCityTable from "../Tables/ServiceCityTable";
import { getServiceCityTableData } from "../../../Services/ServiceCity.service";
import { showAlert } from "../../../Services/Shared.service";
import { size } from "lodash";

export const ServiceCityFlow = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSearch, setIsSearch] = useState(true);
  const [serviceCityData, setServiceCityData] = useState([])
  const [pagination, setPagination] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [isRefresh, setIsRefresh] = useState(false);
  const { cityData,trgiggerRefresh } =
    useContext(SharedDataContext);

  const handleToggle = () => {
    if (!isSearch) {
      setIsSearch(true);
    } else {
      setIsOpen(!isOpen);
    }
  };

  useEffect(() => {
    fetchData()

  }, [])
  useEffect(() => {
    fetchData()

  }, [pagination,rowsPerPage])
  const triggerRefresh = () => {
    setIsRefresh(!isRefresh);
  };
  const onChangePage = (page) => {
    console.log("page", page);
    setPagination(page - 1);
  };
  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };
  
   const fetchData=()=>{
    let obj={
      page:pagination,
      size:rowsPerPage,
    }
    getServiceCityTableData(obj).then(
      (res)=>{
   if(res.data){
    setServiceCityData(res.data.searchResponse)
    console.log("fdfdf",res.data)
    setPaginationTotalRows(res.data.count)
    disableLoaders();
   }
      }
    ).catch((err)=>{
      disableLoaders();
      showAlert("error", err.response?.data?.message
          ? err.response.data.message : "Something went wrong");
    })
   }
   const disableLoaders = () => {
    setLoader(false);
  };
  const tabs = [
    {
      label: "Service City",
      content: (
        <ServiceCityForm
          cityData={cityData}
          setIsSearch={setIsSearch}
          isSearch={isSearch}
          trgiggerRefresh={trgiggerRefresh}
          isRefresh={isRefresh}
        />
      ),
    },
  ];

  return (
    <div>
      <Breadcrumbs
        parent="Configuration"
        subParent="Service City"
        mainTitle="Service City"
        span1={
          <Btn
            attrBtn={{
              style: {
                display: "flex",
                padding: "7px 14px",
                justifyContent: "center",
                alignItems: "center",
              },
              onClick: handleToggle,
            }}
          >
            <Plus size={"18px"} style={{ marginRight: "5px" }} /> Add
          </Btn>
        }
      />

      <Container fluid={true} className="datatables">
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="p-0">
                <ServiceCityTable
                serviceCityData={serviceCityData}
                  isRefresh={isRefresh}
                  trgiggerRefresh={triggerRefresh}
                  onChangePage={onChangePage}
                  onChangeRowsPerPage={onChangeRowsPerPage}
                  paginationTotalRows={paginationTotalRows}
                  loader={loader}
                  setLoader={setLoader}
                  rowsPerPage={rowsPerPage} 
                  setRowsPerPage={setRowsPerPage}
                  fetchData={fetchData}

                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal
        isOpen={isOpen}
        toggle={handleToggle}
        size={"xl"}
        centered
        className="common-modal"
        backdrop="static"
      >
        <ModalHeader toggle={handleToggle} style={{ color: "#41CC7D" }} />

        <ModalBody style={{ paddingBottom: "5%", border: 0 }}>
          <CustomTabs tabs={tabs} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ServiceCityFlow;
